import type { SVGProps } from 'react';

const SystemError = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} width="84" height="73" viewBox="0 0 84 73" fill="none">
        <path
            d="M44.3371 72.2451C65.6682 72.5076 83.0487 65.604 83.1568 56.8216C83.2649 48.0426 66.0595 40.7098 44.7285 40.4472C23.3974 40.1847 8.30922 46.6929 8.20117 55.4719C13.5062 63.073 23.006 71.9825 44.3371 72.2451Z"
            fill="#0A0A0A"
            fill-opacity="0.1"
        />
        <circle cx="36.0002" cy="35.9999" r="33" fill="#D22839" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M36.0025 67.5001C53.3994 67.5001 67.5025 53.397 67.5025 36.0001C67.5025 18.6031 53.3994 4.50006 36.0025 4.50006C18.6055 4.50006 4.50246 18.6031 4.50246 36.0001C4.50246 53.397 18.6055 67.5001 36.0025 67.5001ZM36.0025 72.0001C55.8847 72.0001 72.0025 55.8823 72.0025 36.0001C72.0025 16.1178 55.8847 6.10352e-05 36.0025 6.10352e-05C16.1202 6.10352e-05 0.00246429 16.1178 0.00246429 36.0001C0.00246429 55.8823 16.1202 72.0001 36.0025 72.0001Z"
            fill="#D22839"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.5664 18.5262C19.2675 17.8247 20.4041 17.8247 21.1052 18.5262L37.2897 34.7221L53.4742 50.9179C54.1753 51.6195 54.1753 52.7569 53.4742 53.4585C52.7732 54.16 51.6365 54.16 50.9355 53.4585L18.5664 21.0667C17.8654 20.3652 17.8654 19.2278 18.5664 18.5262Z"
            fill="white"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M53.4336 18.5417C54.1347 19.2432 54.1347 20.3806 53.4336 21.0822L21.0646 53.4739C20.3635 54.1754 19.2269 54.1754 18.5258 53.4739C17.8248 52.7724 17.8248 51.6349 18.5258 50.9334L50.8949 18.5417C51.5959 17.8401 52.7326 17.8401 53.4336 18.5417Z"
            fill="white"
        />
    </svg>
);

export default SystemError;
